import React from 'react';
import { View, Text, Image, StyleSheet, Dimensions } from 'react-native';

const deviceWidth = Dimensions.get('window').width;
const imageProportions = {
  a4: 1.4,
  square: 1,
};
const imageAlignments = {
  center: 'center',
  start: 'flex-start',
  end: 'flex-end',
};

export default function ImageBackgroundContainer({
  children,
  uri,
  imageProportionType,
  imageWidthRelativeToDeviceWidth,
  //   imageHeightRelativeToDeviceWidth,
  imageHorizontalAlignment,
  imageVerticalAlignment,
  containerWidthRelativeToDeviceWidth,
  containerHeightRelativeToDeviceWidth,
  coverColor,
  coverOpacity,
}) {
  const imageProportion = imageProportions[imageProportionType];
  const imageHeightRelativeToDeviceWidth =
    imageProportion * imageWidthRelativeToDeviceWidth;
  const styles = StyleSheet.create({
    container: {
      //   borderColor: 'red',
      //   borderWidth: 5,
      width: containerWidthRelativeToDeviceWidth,
      height: containerHeightRelativeToDeviceWidth,
      overflow: 'hidden',
      justifyContent: imageAlignments[imageHorizontalAlignment],
      alignItems: imageAlignments[imageVerticalAlignment],
    },
    cover: {
      //   borderColor: 'blue',
      //   borderWidth: 5,
      position: 'absolute',
      zIndex: -1,
      bottom: 0,
      width: containerWidthRelativeToDeviceWidth,
      height: containerHeightRelativeToDeviceWidth,
      backgroundColor: coverColor,
      opacity: coverOpacity,
      //   justifyContent: 'center',
      //   alignItems: 'center',
    },
    image: {
      position: 'absolute',
      zIndex: -2,
      width: imageWidthRelativeToDeviceWidth * deviceWidth,
      height: imageHeightRelativeToDeviceWidth * deviceWidth,
    },
  });
  return (
    <View style={styles.container}>
      {children}
      <Image source={{ uri }} style={styles.image} />
      <View style={styles.cover}></View>
    </View>
  );
}
